import { CHART_ITEM_COLORS, PIE_COLORS } from '../constants';

export interface PieDataItem {
	name: string;
	value: number;
	fill: string;
	color?: string;
	percent?: number;
}

export interface ChartDataItem {
	name: string;
	value: number;
	color?: string;
	[key: string]: string | number | undefined;
}

const normalizeChartItemName = (name: string): string => {
	return name
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.trim();
};

export const resolveChartItemColor = (name: string, index: number): string => {
	return CHART_ITEM_COLORS[normalizeChartItemName(name)] ?? PIE_COLORS[index % PIE_COLORS.length];
};

export const enrichPieData = (data: Array<{ name: string; value: number; color?: string; percent?: number }>): PieDataItem[] => {
	return data.map((item, index) => {
		const value = Number(item.value);
		const percent = Number(item.percent);

		return {
			...item,
			value: Number.isFinite(value) ? value : 0,
			percent: Number.isFinite(percent) ? percent : undefined,
			fill: item.color ?? resolveChartItemColor(item.name, index),
		};
	});
};

export const calculateTotal = (data: Array<{ value: number }>): number => {
	return data.reduce((sum, item) => {
		const value = Number(item.value);

		return sum + (Number.isFinite(value) ? value : 0);
	}, 0);
};

export const calculatePercentage = (value: number, total: number): string => {
	if (!Number.isFinite(value) || !Number.isFinite(total) || total <= 0) return '0';

	return ((value / total) * 100).toFixed(0);
};

export const calculateLabelPosition = (
	cx: number,
	cy: number,
	midAngle: number,
	innerRadius: number,
	outerRadius: number
): { x: number; y: number } => {
	const RADIAN = Math.PI / 180;
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);
	return { x, y };
};
